import { withTheme } from 'theme';
import CustomerList from './CustomerList';
import { CustomerProfileContainer } from './CustomerProfile';
var WTCustomerList = withTheme(CustomerList);
var WTCustomerProfile = withTheme(CustomerProfileContainer);
export { WTCustomerList, WTCustomerProfile };
//# sourceMappingURL=index.withTheme.js.map